export const SEPARATOR = '...';
export const truncate = (
  str = '',
  numberOfCharsToShowInStart: number,
  numberOfCharsToShowInEnd: number,
): string => {
  const stringLength = str.length;
  const start = numberOfCharsToShowInStart;
  const end = numberOfCharsToShowInEnd;

  if (stringLength <= start) {
    return str;
  }

  const front = str.substr(0, start);

  const back = stringLength - start > end ? str.substr(str.length - end) : '';

  return front + SEPARATOR + back;
};
